import { formatDateTimeZone } from './formatDateTimeZone';

export const getCompletedDateTime = (completedDate, completedTime, userTimeZone) => {
  if (!completedDate || !completedTime) return '';
  const dateTimeUTC = `${completedDate}T${completedTime}Z`;

  const formatted = formatDateTimeZone(dateTimeUTC, userTimeZone, 'YYYY-MM-DD/LT');
  if (!formatted) return '';
  const [date, time] = formatted.split('/');
  if (!date || !time) return '';

  return { date, hourTime: time };
};
